import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.DELETE_SECTION + actions.FULFILLED:
        case actions.GET_COURSE + actions.FULFILLED:
        case actions.UPDATE_COURSE + actions.FULFILLED:
        case actions.COPY_SECTION + actions.FULFILLED:
            return fromJS(action.payload);

        case actions.SET_COURSE_FIELD:
            return state.set(action.field, action.payload);

        case actions.NEW_COURSE:
            return getInitialState();

        case actions.NEW_SECTION:
            return getInitialState().set('parentCourseId', action.payload);

        case actions.ADD_COURSE_SECTIONS: {
            const parentCourseId = state.get('courseId');

            return state.update('sections', sections => {
                action.payload.forEach(section => {

                    const exists = sections.find(x => x.get('courseId') === section.courseId)

                    if (!exists)
                       sections = sections.push(fromJS({ parentCourseId, ...section }));

                });
                return sections;
            });
        }

        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({
        sessionId: null,
        name: '',
        isActive: true
    });
};